<script setup>
import { cn } from "@/shared/lib/utils";
import TableCell from "./TableCell.vue";
import TableRow from "./TableRow.vue";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  colspan: { type: Number, default: 1 },
});
</script>

<template>
  <TableRow class="border-b-0 hover:bg-transparent">
    <TableCell
      :class="
        cn(
          'p-4 whitespace-nowrap align-middle text-sm text-foreground',
          props.class
        )
      "
      :colspan="colspan"
    >
      <div class="flex items-center justify-center py-10">
        <slot />
      </div>
    </TableCell>
  </TableRow>
</template>
